'use client';

import React from 'react';
import DonateHero from './DonateHero';
import DonationForm from './DonationForm';
import ImpactSection from './ImpactSection';
import TransparencySection from './TransparencySection';
import MembershipSection from './MembershipSection';
import VolunteerSection from './VolunteerSection';

const DonateInteractive = () => {
  return (
    <div className="min-h-screen">
      <DonateHero />
      <DonationForm />
      <ImpactSection />
      <MembershipSection />
      <VolunteerSection />
      <TransparencySection />
    </div>
  );
};

export default DonateInteractive;